export default "__VITE_ASSET__1c642d97__"